import React from 'react'
import { ApolloError } from '@apollo/client'
import { Pagination } from 'transfix-ui/components/Pagination'
import { makeStyles } from 'transfix-ui/core'
import { IShippersQuery } from '../ShippersPage/graphql/Shippers'
import { ShipperTable } from './components'
import { TPageCursor } from './types'

export const ITEMS_PER_PAGE = 20

export interface IShipperListProps {
  data: IShippersQuery | undefined
  currentPageNumber: number
  setCurrentPageCursorInfo: React.Dispatch<React.SetStateAction<TPageCursor>>
  setCurrentPageNumber: React.Dispatch<React.SetStateAction<number>>
  loading: boolean
  error: ApolloError | undefined
}

const useShipperListStyles = makeStyles(theme => ({
  headerControls: {
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  paginationContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(8),
  },
}))

const ShipperList = ({
  currentPageNumber,
  data,
  error,
  loading,
  setCurrentPageCursorInfo,
  setCurrentPageNumber,
}: IShipperListProps) => {
  const classes = useShipperListStyles()

  const { searchShipperApplications } = data || {}
  const { nodes: items = [], pageInfo, totalCount = 0 } = searchShipperApplications || {}
  const { endCursor, startCursor } = pageInfo || {}

  const pageChangeHandler = (newPageNumber: number) => {
    const goNext = newPageNumber > currentPageNumber

    if (goNext) {
      setCurrentPageCursorInfo({ after: endCursor })
    } else {
      setCurrentPageCursorInfo({ before: startCursor })
    }

    setCurrentPageNumber(newPageNumber)
  }

  return (
    <>
      <ShipperTable items={items || []} isLoading={loading} error={error} />
      <div className={classes.paginationContainer}>
        <Pagination
          currentPage={currentPageNumber}
          loading={loading}
          numberOfPages={Math.ceil(totalCount / ITEMS_PER_PAGE)}
          onPageChange={pageChangeHandler}
        />
      </div>
    </>
  )
}

export default ShipperList
